import axios from 'axios'

export const register = newUser => {
  return axios
    .post('https://apis.pixelbyhand.com/clients/register', {
      id :  newUser.id,
      firstname: newUser.firstname,
      lastname: newUser.lastname,
      imagescounts: newUser.imagescounts,
      imagesframe: newUser.imagesframe,
      bussiness: newUser.bussiness,
      email: newUser.email,
      password: newUser.password,
      note: newUser.note,
      zipfile: newUser.zipfile
    })
    .then(response => {
      console.log('Registered')
    })
}

export const login = user => {
  return axios
    .post('https://apis.pixelbyhand.com/clients/login', {
      email: user.email,
      password: user.password
    })
    .then(response => {
      localStorage.setItem('usertoken', response.data)
      return response.data
    })
    .catch(err => {
      console.log(err)
    })
}
